export class RetailerTransactionStatementsModel {
  retailerCompanyName: string;
  closedSales: ClosedSalesModel[];
  closedSalesTotals: ClosedSalesTotalsModel;
  payoutSummary: PayoutSummaryModel[];
  payoutTotals: PayoutSummaryTotalsModel;
  grandTotals: GrandTotalsModel;
  startDate: string;
  endDate: string;

  constructor(obj: any = {}) {
    obj = obj || {};

    this.retailerCompanyName = obj.retailerCompanyName;
    this.closedSales = obj.closedSales;
    this.closedSalesTotals = obj.closedSalesTotals;
    this.payoutSummary = obj.payoutSummary;
    this.payoutTotals = obj.payoutTotals;
    this.grandTotals = obj.grandTotals;
    this.startDate = obj.startDate;
    this.endDate = obj.endDate;
  }
}

export class ClosedSalesModel {
  tradingDate: string;
  totalSales: number;
  platformPayments: number;
  externalPayments: number;
  charges: number;
  vatOnCharges: number;
  settlementBalance: number;


  constructor(obj: any = {}) {
    obj = obj || {};

    this.tradingDate = obj.tradingDate;
    this.totalSales = obj.totalSales;
    this.platformPayments = obj.platformPayments;
    this.externalPayments = obj.externalPayments;
    this.charges = obj.charges;
    this.vatOnCharges = obj.vatOnCharges;
    this.settlementBalance = obj.settlementBalance;
  }
}

export class ClosedSalesTotalsModel {
  totalSales: number;
  platformPayments: number;
  externalPayments: number;
  charges: number;
  vatOnCharges: number;
  settlementBalance: number;


  constructor(obj: any = {}) {
    obj = obj || {};

    this.totalSales = obj.totalSales;
    this.platformPayments = obj.platformPayments;
    this.externalPayments = obj.externalPayments;
    this.charges = obj.charges;
    this.vatOnCharges = obj.vatOnCharges;
    this.settlementBalance = obj.settlementBalance;
  }
}


export class PayoutSummaryModel {
  payoutDate: string;
  processedDate: string;
  earliestTransactionDate: string;
  latestTransactionDate: string;
  totalSales: number;
  chargesVatIncl: number;
  settlementHold: number;
  tenantSettlement: number;
  totalPaid: number;


  constructor(obj: any = {}) {
    obj = obj || {};

    this.payoutDate = obj.payoutDate;
    this.processedDate = obj.processedDate;
    this.totalSales = obj.totalSales;
    this.settlementHold = obj.settlementHold;
    this.chargesVatIncl = obj.chargesVatIncl;
    this.tenantSettlement = obj.tenantSettlement;
    this.totalPaid = obj.totalPaid;
    this.latestTransactionDate = obj.latestTransactionDate;
    this.earliestTransactionDate = obj.earliestTransactionDate;
  }
}

export class PayoutSummaryTotalsModel {

  totalSales: number;
  settlementHold: number;
  chargesVatIncl: number;
  tenantSettlement: number;
  totalPaid: number;


  constructor(obj: any = {}) {

    obj = obj || {};

    this.totalSales = obj.totalSales;
    this.settlementHold = obj.settlementHold;
    this.chargesVatIncl = obj.chargesVatIncl;
    this.tenantSettlement = obj.tenantSettlement;
    this.totalPaid = obj.totalPaid;
  }
}

export class GrandTotalsModel {
  totalSales: number
  totalChargesIncl: number
  totalExternalPayments: number
  totalSettlementHolds: number;
  totalSettled: number
  settlementBalanceForPeriod: number


  constructor(obj: any = {}) {
    obj = obj || {};


    this.totalSales = obj.totalSales;
    this.totalChargesIncl = obj.totalChargesIncl;
    this.totalExternalPayments = obj.totalExternalPayments;
    this.totalSettlementHolds = obj.totalSettlementHolds;
    this.totalSettled = obj.totalSettled;
    this.settlementBalanceForPeriod = obj.settlementBalanceForPeriod;
  }
}

